var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-nav-bar',{attrs:{"title":_vm.title},on:{"click-right":_vm.onClickLeft},scopedSlots:_vm._u([{key:"right",fn:function(){return [_c('van-icon',{attrs:{"name":"scan","size":"25","color":"#555"}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }